<template>
     <form>
           <fg-input
                type="tel"
                label="Номер телефона"
                v-model="phone"
                name="phone"
                placeholder="+998"
                v-mask="`+998#########`"
                :readonly="is_sent"
              ></fg-input>


             <label class="mb-2"> Используя функционал платформы AVEDU, вы соглашаетесь с <span class="link" @click="$modal.show('policy')">условиями политикой конфиденциальности</span></label>

          <template v-if="is_sent">
              <fg-input
                type="tel"
                name="code_sms"
                label="Код из смс"
                v-model="code"
                placeholder="*****"
                v-mask="`#####`"
              ></fg-input>
              <br />
              <p-button
                  v-if="is_sent"
                  class="w-100 mb-3"
                  type="warning"
                  round
                  @click.native.prevent="verify"
                  >{{'accept' | setText('Подтвердить')}}</p-button
                >
              <p-button   class="w-100 mb-3" @click.native.prevent="reset">{{'reset_phone' | setText('Сбросить номер')}}</p-button>
          </template>


    
             <p-button
                v-else
                class="w-100 mb-3"
                type="warning"
                round
                @click.native.prevent="send"
                >{{'next' | setText('Продолжить')}}</p-button
              >
    </form>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

export default {
  name: "login",
  components: {},
  props:{
    is_restore:{
      default:false
    }
  },
  data() {
    return {
      phone: "+998",
      code: "",
      is_sent: false,
    };
  },
  methods: {
    reset(){
      this.is_sent = false;
      this.phone = "+998";
      this.code = "";
    },
    verify(loading = true) {
      this.$loading(true);
      this.$http
        .post("auth/code/verify", {
          phone: this.phone,
          code: this.code,
        })
        .then((response) => {
         // console.log(response.data);
          this.$emit('verified',response.data);
        })
        .catch((error) => {
          this.code = "";
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
    send(loading = true) {
      this.$loading(true);
      this.$http
        .post("auth/code", {
          phone: this.phone,
          is_restore: this.is_restore
        })
        .then((response) => {
            this.is_sent = true;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.code = "";
          setTimeout(() => {
            this.$loading(false);
          }, 200);
        });
    },
  },
};
</script>
